export const MAX_BALLS = 500000;
export const MAX_RINGS = 100000;

export class WebGLContext {
  public gl: WebGL2RenderingContext;
  public width: number = 0;
  public height: number = 0;
  public geoBuffer: WebGLBuffer;

  constructor(canvas: HTMLCanvasElement) {
    const gl = canvas.getContext('webgl2', { alpha: true, antialias: false });
    if (!gl) throw new Error('WebGL2 not supported');
    this.gl = gl;

    this.gl.enable(this.gl.BLEND);
    this.gl.blendFunc(this.gl.SRC_ALPHA, this.gl.ONE_MINUS_SRC_ALPHA);

    // Common geometry buffer for all renderers (a simple quad)
    const quadPos = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]);
    this.geoBuffer = this.gl.createBuffer()!;
    this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.geoBuffer);
    this.gl.bufferData(this.gl.ARRAY_BUFFER, quadPos, this.gl.STATIC_DRAW);
  }

  resize(width: number, height: number) {
    this.width = width;
    this.height = height;
    this.gl.viewport(0, 0, width, height);
  }

  clear() {
    this.gl.clearColor(0, 0, 0, 0);
    this.gl.clear(this.gl.COLOR_BUFFER_BIT);
  }

  createAttribBuffer(loc: number, size: number, byteLength: number): WebGLBuffer {
    const buf = this.gl.createBuffer()!;
    this.gl.bindBuffer(this.gl.ARRAY_BUFFER, buf);
    this.gl.bufferData(this.gl.ARRAY_BUFFER, byteLength, this.gl.DYNAMIC_DRAW);
    this.gl.enableVertexAttribArray(loc);
    this.gl.vertexAttribPointer(loc, size, this.gl.FLOAT, false, 0, 0);
    this.gl.vertexAttribDivisor(loc, 1);
    return buf;
  }
}
